import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { WebCompany, WebCustomer, WebSettings } from "../../../models";
import { Subscription } from "rxjs";
import { CompanyService, CustomerService, SharedService } from "src/app/services";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { filter } from "rxjs/operators";


@Component({
  selector: "app-request-delivery-dialog",
  templateUrl: "./request-delivery-dialog.component.html",
  styleUrls: ["./request-delivery-dialog.component.scss"],
})
export class RequestDeliveryDialogComponent implements OnInit
{

  customer: WebCustomer;
  company: WebCompany;
  customerSubscription: Subscription;
  companySubscription: Subscription;
  showHeaderInfo: boolean;
  showDefaultDisclaimerText: boolean;

  webSettingsSubscription: Subscription;
  deliveryDisclaimer: SafeHtml;
  webSettings: WebSettings;

  constructor(
    public dialogRef: MatDialogRef<RequestDeliveryDialogComponent>,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void
  {
    this.showHeaderInfo = true;

    this.webSettingsSubscription = this.companyService.webSettings.subscribe(s => 
    {
      this.webSettings = s;
      const parser = new DOMParser();
      const doc = parser.parseFromString(s?.DeliveryDisclaimer || '', 'text/html');
      const hasImage = doc.querySelector('img') !== null;
      if (!hasImage && s?.DeliveryDisclaimerText?.length < 1)
      {
        this.showDefaultDisclaimerText = true;
      }
      else
      {
        this.showDefaultDisclaimerText = false;
        this.setDeliveryDisclaimer();
      }
    });

    this.customerSubscription = this.customerService.customer
      .pipe(filter(customer => !!customer))
      .subscribe(customer =>
      {
        this.customer = customer;
      });


    this.companySubscription = this.companyService.company.subscribe(c =>
    {
      this.company = c;
    });
  }


  setDeliveryDisclaimer(): void
  {
    const rawDisclaimer = this.webSettings.DeliveryDisclaimer;
    const edited = this.editDisclaimer(rawDisclaimer);
    this.deliveryDisclaimer = this.sanitizer.bypassSecurityTrustHtml(edited);
  }


  editDisclaimer(content: string): string
  {
    let newString = content;

    if (this.sharedService.isDark)
    {
      newString = newString.replace("body { ", "body { color: #ffffff !important; ");
      newString = newString.replace(/color:\s*#000000/gi, "color: #ffffff");
      newString = newString.replace(/color:\s*#333333/gi, "color: #ffffff");
    }

    newString = newString.replace(/verdana|arial|calibri/gi, "Roboto");

    return newString;
  }

  ngOnDestroy(): void
  {
    this.webSettingsSubscription?.unsubscribe();
    this.companySubscription?.unsubscribe();
    this.customerSubscription?.unsubscribe();
  }
}
